export function HeroIllustration({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 400 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Dashboard Frame */}
      <rect
        x="20"
        y="20"
        width="360"
        height="280"
        rx="16"
        fill="white"
        fillOpacity="0.1"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="1.5"
      />

      {/* Header Bar */}
      <rect x="36" y="36" width="100" height="8" rx="4" fill="white" fillOpacity="0.3" />
      <rect x="36" y="50" width="60" height="6" rx="3" fill="white" fillOpacity="0.15" />

      {/* Metric Cards Row */}
      <g>
        {/* Card 1 */}
        <rect x="36" y="72" width="75" height="50" rx="8" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.15" />
        <rect x="46" y="82" width="30" height="5" rx="2.5" fill="white" fillOpacity="0.2" />
        <text x="46" y="110" fill="white" fillOpacity="0.9" fontSize="14" fontWeight="600">47</text>

        {/* Card 2 */}
        <rect x="119" y="72" width="75" height="50" rx="8" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.15" />
        <rect x="129" y="82" width="35" height="5" rx="2.5" fill="white" fillOpacity="0.2" />
        <text x="129" y="110" fill="#FCD34D" fontSize="14" fontWeight="600">3</text>

        {/* Card 3 */}
        <rect x="202" y="72" width="75" height="50" rx="8" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.15" />
        <rect x="212" y="82" width="28" height="5" rx="2.5" fill="white" fillOpacity="0.2" />
        <text x="212" y="110" fill="#F87171" fontSize="14" fontWeight="600">1</text>

        {/* Card 4 */}
        <rect x="285" y="72" width="75" height="50" rx="8" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.15" />
        <rect x="295" y="82" width="40" height="5" rx="2.5" fill="white" fillOpacity="0.2" />
        <text x="295" y="110" fill="#4ADE80" fontSize="14" fontWeight="600">43</text>
      </g>

      {/* Position Utilization Section */}
      <rect x="36" y="136" width="200" height="148" rx="10" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.15" />
      <rect x="48" y="148" width="80" height="6" rx="3" fill="white" fillOpacity="0.25" />

      {/* Position Bars */}
      <g>
        {/* Bar 1 - Yellow (85%) */}
        <rect x="48" y="166" width="40" height="5" rx="2.5" fill="white" fillOpacity="0.2" />
        <rect x="48" y="176" width="176" height="8" rx="4" fill="white" fillOpacity="0.1" />
        <rect x="48" y="176" width="150" height="8" rx="4" fill="#FCD34D" fillOpacity="0.8" />

        {/* Bar 2 - Green (45%) */}
        <rect x="48" y="198" width="35" height="5" rx="2.5" fill="white" fillOpacity="0.2" />
        <rect x="48" y="208" width="176" height="8" rx="4" fill="white" fillOpacity="0.1" />
        <rect x="48" y="208" width="80" height="8" rx="4" fill="#4ADE80" fillOpacity="0.8" />

        {/* Bar 3 - Red (92%) */}
        <rect x="48" y="230" width="45" height="5" rx="2.5" fill="white" fillOpacity="0.2" />
        <rect x="48" y="240" width="176" height="8" rx="4" fill="white" fillOpacity="0.1" />
        <rect x="48" y="240" width="162" height="8" rx="4" fill="#F87171" fillOpacity="0.8" />

        {/* Bar 4 - Green (65%) */}
        <rect x="48" y="262" width="50" height="5" rx="2.5" fill="white" fillOpacity="0.2" />
        <rect x="48" y="272" width="176" height="8" rx="4" fill="white" fillOpacity="0.1" />
        <rect x="48" y="272" width="115" height="8" rx="4" fill="#4ADE80" fillOpacity="0.8" />
      </g>

      {/* Alerts Panel */}
      <rect x="248" y="136" width="112" height="148" rx="10" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.15" />
      <rect x="260" y="148" width="50" height="6" rx="3" fill="white" fillOpacity="0.25" />

      {/* Alert Items */}
      <g>
        {/* Alert 1 */}
        <rect x="260" y="166" width="88" height="32" rx="6" fill="#FCD34D" fillOpacity="0.15" />
        <circle cx="272" cy="182" r="4" fill="#FCD34D" />
        <rect x="282" y="175" width="56" height="4" rx="2" fill="white" fillOpacity="0.3" />
        <rect x="282" y="183" width="40" height="3" rx="1.5" fill="white" fillOpacity="0.15" />

        {/* Alert 2 */}
        <rect x="260" y="206" width="88" height="32" rx="6" fill="#FCD34D" fillOpacity="0.15" />
        <circle cx="272" cy="222" r="4" fill="#FCD34D" />
        <rect x="282" y="215" width="50" height="4" rx="2" fill="white" fillOpacity="0.3" />
        <rect x="282" y="223" width="36" height="3" rx="1.5" fill="white" fillOpacity="0.15" />

        {/* Alert 3 */}
        <rect x="260" y="246" width="88" height="32" rx="6" fill="white" fillOpacity="0.1" />
        <circle cx="272" cy="262" r="4" fill="#A78BFA" />
        <rect x="282" y="255" width="60" height="4" rx="2" fill="white" fillOpacity="0.3" />
        <rect x="282" y="263" width="44" height="3" rx="1.5" fill="white" fillOpacity="0.15" />
      </g>

      {/* Decorative Elements */}
      <circle cx="340" y="44" r="8" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.2" />
      <circle cx="340" y="44" r="4" fill="#4ADE80" fillOpacity="0.8" />
    </svg>
  );
}
